import type { IxcPortfolioV1AssetBalanceKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const getPortfolioAssetBalancePath: EntityPathBuilder<IxcPortfolioV1AssetBalanceKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      if (!context?.keys) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/asset', context.keys);
    case 'detail': {
      if (!context?.keys?.assetId) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/asset/$assetId', context.keys);
    }
  }
};

export function getPortfolioAssetBalanceDetailPath(accountId: string | undefined, assetId: string | undefined) {
  if (!accountId || !assetId) {
    return undefined;
  }

  return getPortfolioAssetBalancePath({ kind: 'detail', keys: { accountId, assetId } });
}
